import { CartAddEvent } from '@theme/events';

/**
 * Cart drawer add-on offers (B leg of the cart add-ons test).
 * Handles swatch selection for the appliance offer and one-tap adds.
 * After a successful add it dispatches CartAddEvent, which the drawer
 * already listens for - the re-render removes the claimed offer.
 */
class ArtieCartAddons extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', this.#onClick);
    this.addEventListener('change', this.#onChange);
  }

  #onChange = (event) => {
    const input = event.target;
    if (!(input instanceof HTMLInputElement) || input.name !== 'artie-addon-system-variant') return;
    const offer = input.closest('[data-addon-offer="system"]');
    if (!offer) return;
    const priceEl = offer.querySelector('[data-addon-system-price]');
    if (priceEl && input.dataset.price) priceEl.textContent = input.dataset.price;
    const imageEl = offer.querySelector('[data-addon-system-image]');
    if (imageEl instanceof HTMLImageElement && input.dataset.image) imageEl.src = input.dataset.image;
    const addBtn = offer.querySelector('[data-addon-add]');
    if (addBtn instanceof HTMLElement) addBtn.dataset.variantId = input.value;
  };

  #onClick = async (event) => {
    const btn = event.target instanceof Element ? event.target.closest('[data-addon-add]') : null;
    if (!(btn instanceof HTMLButtonElement) || btn.disabled) return;

    const role = btn.dataset.addonRole || 'secondary';
    let variantId = btn.dataset.variantId;
    if (role === 'system') {
      const checked = this.querySelector('input[name="artie-addon-system-variant"]:checked');
      if (checked instanceof HTMLInputElement && checked.value) variantId = checked.value;
    }
    if (!variantId) return;

    btn.disabled = true;
    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [
            {
              id: Number(variantId),
              quantity: 1,
              properties: { _artie_line: role },
            },
          ],
        }),
      });
      const data = await response.json();
      if (!response.ok) throw new Error(data && data.description ? data.description : 'Add to cart failed');

      document.dispatchEvent(
        new CartAddEvent({}, 'artie-cart-addons', {
          source: 'artie-cart-addons',
          itemCount: 1,
          variantId: String(variantId),
        })
      );
    } catch (error) {
      console.error('[Artie] Cart add-on add failed:', error);
      btn.disabled = false;
    }
  };
}

if (!customElements.get('artie-cart-addons')) {
  customElements.define('artie-cart-addons', ArtieCartAddons);
}

/**
 * Drawer scroll repair. On iOS, rapid add/remove cycles can leave the
 * drawer's scroller with a scrollTop beyond the shrunken content (dead
 * blank zone, gesture goes to the scroll-locked body → feels frozen)
 * and a row stuck mid `removing` animation. After each cart morph
 * settles, clamp the offset and clear stray removal states.
 */
function artieRepairDrawerScroll() {
  const items = document.querySelector('.cart-drawer__items');
  if (items) {
    const max = Math.max(0, items.scrollHeight - items.clientHeight);
    if (items.scrollTop > max) items.scrollTop = max;
  }
  document.querySelectorAll('.cart-items__table-row.removing').forEach((row) => {
    row.classList.remove('removing');
  });
  const annotate = /** @type {{ artieAnnotateCartPerMealOffers?: () => void }} */ (window)
    .artieAnnotateCartPerMealOffers;
  if (typeof annotate === 'function') annotate();
}
document.addEventListener('cart:update', () => {
  setTimeout(artieRepairDrawerScroll, 350);
  setTimeout(artieRepairDrawerScroll, 1000);
});
